import {
  ABACPolicyFormDefaultValues,
  ABACPolicyFormProps,
  ABACPolicyFormRawValues,
  ABACPolicyFormType
} from "./ABACPolicyForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";

const getInitialValues = (defaultValues: ABACPolicyFormDefaultValues | undefined): ABACPolicyFormRawValues => {
  return {
    name: defaultValues?.name,
    description: defaultValues?.description,
    expression: defaultValues?.expression,
  }
}

export type UseABACPolicyFormProps = Pick<ABACPolicyFormProps, 'defaultValues'> & {}

export function useABACPolicyForm(props: UseABACPolicyFormProps): ABACPolicyFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
      expression: defaultValues.expression ?? '{}',
    }),
    validate: {
      name: (value) => value ? undefined : t("common.validation.required", "Required"),
      expression: (value) => {
        if (value) {
          try {
            JSON.parse(value);
            return undefined;
          } catch {
            return t("common.validation.invalid.json", "Invalid JSON. Please check your syntax and try again.")
          }
        } else {
          return t("common.validation.required", "Required")
        }
      },
    },
  })

  return form
}
